class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.dialogManager = null;
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
  }

  connectedCallback() {
    if (!this.notification) return;

    // Wait for DialogManager to be available
    if (window.DialogManager) {
      this.init();
    } else {
      const checkInterval = setInterval(() => {
        if (window.DialogManager) {
          clearInterval(checkInterval);
          this.init();
        }
      }, 50);
    }
  }

  init() {
    const closeButtons = this.querySelectorAll('button[type="button"]');

    // Create DialogManager instance
    this.dialogManager = new DialogManager(this.notification, {
      type: 'popup',
      closeElements: Array.from(closeButtons),
      closeOnEscape: true,
      closeOnOverlayClick: false, // Custom body click handler instead
      preventBodyScroll: false,
      focusFirstElement: false, // Focus the notification element itself
      inertBackgroundElements: false,
      animationDuration: 300,
      onOpen: () => {
        // Add custom body click handler
        document.body.addEventListener('click', this.onBodyClick);
        
        // Focus the notification after animation
        setTimeout(() => {
          this.notification.focus();
        }, 300);
      },
      onClose: () => {
        // Remove custom body click handler
        document.body.removeEventListener('click', this.onBodyClick);
        
        // Focus the active element if set
        if (this.activeElement) {
          this.activeElement.focus();
          this.activeElement = null;
        }
      }
    });

    // Bind body click handler
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Set aria-label
    this.notification.setAttribute('aria-label', 'Added to cart notification');
  }

  open() {
    // Add animation classes for compatibility
    this.notification.classList.add('animate', 'active');
    
    // Open with DialogManager
    this.dialogManager?.open();
    
    // Reveal sticky header if present
    if (this.header) this.header.reveal();
  }

  close() {
    // Remove animation classes
    this.notification.classList.remove('active');
    
    // Close with DialogManager
    this.dialogManager?.close();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'header-basket') {
        // Special handling for cart icon bubble - replace the entire element
        const currentCartIcon = document.getElementById('header-basket');
        if (currentCartIcon) {
          const newCartIconHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = newCartIconHTML;
          const newCartIcon = tempDiv.firstElementChild;
          currentCartIcon.replaceWith(newCartIcon);
          
          // Re-initialize cart drawer trigger if needed
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.dialogManager) {
            cartDrawer.dialogManager.options.triggerElement = document.querySelector('#header-basket');
          }
        }
      } else {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'header-basket',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
